import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, XCircle } from 'lucide-react';
const notifications = [{
  n: 'Valentina M.',
  l: 'Buenos Aires',
  t: 'hace 6 minutos',
  p: 'la Colección Completa 💛'
}, {
  n: 'Lucía G.',
  l: 'Córdoba',
  t: 'hace 2 minutos',
  p: 'la Colección + Organizador ⭐'
}, {
  n: 'Marcos P.',
  l: 'Rosario',
  t: 'hace 15 minutos',
  p: 'la Colección Completa 💛'
}, {
  n: 'Elena S.',
  l: 'Mendoza',
  t: 'hace 8 minutos',
  p: 'la Colección + Organizador ⭐'
}, {
  n: 'Javier R.',
  l: 'Salta',
  t: 'hace 22 minutos',
  p: 'la Colección Completa 💛'
}, {
  n: 'Sofía B.',
  l: 'La Plata',
  t: 'hace 4 minutos',
  p: 'la Colección + Organizador ⭐'
}, {
  n: 'Diego T.',
  l: 'Mar del Plata',
  t: 'hace 31 minutos',
  p: 'la Colección Completa 💛'
}, {
  n: 'Martina L.',
  l: 'Neuquén',
  t: 'hace 12 minutos',
  p: 'la Colección + Organizador ⭐'
}, {
  n: 'Andrés F.',
  l: 'Tucumán',
  t: 'hace 5 minutos',
  p: 'la Colección Completa 💛'
}, {
  n: 'Paula V.',
  l: 'Posadas',
  t: 'hace 18 minutos',
  p: 'la Colección + Organizador ⭐'
}, {
  n: 'Bruno D.',
  l: 'Santa Fe',
  t: 'hace 10 minutos',
  p: 'la Colección Completa 💛'
}, {
  n: 'Camila O.',
  l: 'Bahía Blanca',
  t: 'hace 7 minutos',
  p: 'la Colección + Organizador ⭐'
}, {
  n: 'Gabriel N.',
  l: 'San Juan',
  t: 'hace 25 minutos',
  p: 'la Colección + Organizador ⭐'
}];
export function FloatingNotification() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const initialTimeout = setTimeout(() => setVisible(true), 3000);
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % notifications.length);
        setVisible(true);
      }, 1000);
    }, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const current = notifications[currentIndex];
  return <AnimatePresence data-id="element-75">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-6 left-6 z-50 bg-white shadow-2xl rounded-lg p-4 border border-slate-100 flex items-center gap-4 max-w-sm" data-id="element-76">
          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-[#10A37F]" data-id="element-77">
            <Check size={20} data-id="element-78" />
          </div>
          <div data-id="element-79">
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-80">
              Compra verificada
            </p>
            <p className="text-sm text-slate-800" data-id="element-81">
              <span className="font-bold" data-id="element-82">{current.n}</span> de {current.l}
              <br data-id="element-83" />
              compró {current.p}
            </p>
            <p className="text-xs text-slate-400 mt-1" data-id="element-84">{current.t}</p>
          </div>
          <button onClick={() => setVisible(false)} className="text-slate-300 hover:text-slate-500" data-id="element-85">
            <XCircle size={16} data-id="element-86" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}